var ShowPasswordViewModel;

ShowPasswordViewModel = (function() {
  function ShowPasswordViewModel(params) {
    if (params.getPassword === null || typeof params.getPassword !== 'function') {
      throw 'A parameter \'getPassword\' is required and must be a function';
    }
    this.loading = ko.observable(false);
    this.errored = ko.observable(false);
    this.showPassword = ko.observable(false);
    this.timer = null;
    this.password = ko.observable('');
    this.fetchPassword = (function(_this) {
      return function() {
        var result;
        _this.loading(true);
        _this.errored(false);
        _this.showPassword(true);
        result = params.getPassword();
        if (helpers.isDeferred(result)) {
          result.always(function() {
            return _this.loading(false);
          });
          result.fail(function() {
            return _this.errored(true);
          });
          return result.done(function(result) {
            if (typeof result === 'object') {
              return _this.password(result.password);
            } else {
              return _this.password(result);
            }
          });
        } else {
          _this.loading(false);
          _this.errored(false);
          if (typeof result === 'object') {
            return _this.password(result.password);
          } else {
            return _this.password(result);
          }
        }
      };
    })(this);
    this.retryHandler = (function(_this) {
      return function() {
        _this.fetchPassword();
        return false;
      };
    })(this);
    this.clickHandler = (function(_this) {
      return function() {
        if (_this.showPassword()) {
          _this.showPassword(false);
          _this.errored(false);
          _this.loading(false);
        } else {
          _this.fetchPassword();
        }
        return false;
      };
    })(this);
    this.mouseOver = (function(_this) {
      return function() {
        if (_this.timer) {
          return window.clearTimeout(_this.timer);
        }
      };
    })(this);
    this.mouseExit = (function(_this) {
      return function() {
        if (_this.showPassword() && !_this.loading()) {
          return _this.timer = window.setTimeout(function() {
            _this.showPassword(false);
            _this.errored(false);
            return _this.loading(false);
          }, 15000);
        }
      };
    })(this);
  }

  return ShowPasswordViewModel;

})();
